import React from "react";
import { Modal } from "react-bootstrap";
import { formatCellValue } from "./utils";

const DetailsModal = ({ show, onHide, record }) => (
  <Modal show={show} onHide={onHide} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>Report Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {record && (
        <div className="table-responsive">
          <table className="table table-sm mb-0">
            <tbody>
              {Object.entries(record)
                .filter(([key]) => !["id", "retry"].includes(key))
                .map(([key, value]) => (
                  <tr key={key}>
                    <th style={{ width: "34%" }}>{key}</th>
                    <td>{formatCellValue(value)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal.Body>
  </Modal>
);

export default DetailsModal;
